"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    id: "uuid-67a03806-03b6-475c-8b7e-70d24281e039",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 344 344",
    width: "100%",
    height: "100%",
    children: [(0, jsx_runtime_1.jsx)("rect", {
      x: "7",
      y: "7",
      width: "330",
      height: "330",
      rx: "24",
      ry: "24",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "14px"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "172",
      cy: "172",
      r: "114.94",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "13px"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "172",
      cy: "172",
      r: "88.5",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "13px"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "52.02",
      cy: "50.96",
      r: "20.4",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8px"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "291.98",
      cy: "50.96",
      r: "20.4",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "9px"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "104.1",
      cy: "40.76",
      r: "10.2",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8px"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "239.9",
      cy: "40.76",
      r: "10.2",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8px"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "41.82",
      cy: "99.07",
      r: "10.2",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8px"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "302.18",
      cy: "99.07",
      r: "10.2",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8px"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "41.82",
      cy: "244.66",
      r: "10.2",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8px"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "302.18",
      cy: "244.66",
      r: "10.2",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8px"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "52.02",
      cy: "293.51",
      r: "20.4",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8px"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "291.98",
      cy: "293.51",
      r: "20.4",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "9px"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "104.1",
      cy: "303.71",
      r: "10.2",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8px"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "239.9",
      cy: "303.71",
      r: "10.2",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "8px"
    })]
  });
};

exports.default = Icon;